namespace RedBullMOBILE360.SMPPAccount {
    export interface SMPPAccountRow {
        AccountId?: number;
        SystemId?: string;
    }

    export namespace SMPPAccountRow {
        export const idProperty = 'AccountId';
        export const nameProperty = 'SystemId';
        export const localTextPrefix = 'SMPPAccount.SMPPAccount';
        export const lookupKey = 'SMPPAccount.SMPPAccount';

        export function getLookup(): Q.Lookup<SMPPAccountRow> {
            return Q.getLookup<SMPPAccountRow>('SMPPAccount.SMPPAccount');
        }
        export const deletePermission = 'y';
        export const insertPermission = 'y';
        export const readPermission = 'y';
        export const updatePermission = 'y';

        export declare const enum Fields {
            AccountId = "AccountId",
            SystemId = "SystemId"
        }
    }
}
